import { useEffect } from 'react';

// Pulls the current page back when it points past the last page of results.
export const useClampPage = (currentPage: number, totalPages: number | undefined, setCurrentPage: (page: number) => void) => {
  useEffect(() => {
    // Wait until pagination metadata has been returned by the API.
    if (totalPages === undefined) return;

    // Empty result sets may report zero pages, but page params should remain at least 1.
    const lastPage = Math.max(totalPages, 1);

    // Filters or searches may reduce the number of available pages.
    if (currentPage > lastPage) {
      setCurrentPage(lastPage);
    }
  }, [currentPage, totalPages, setCurrentPage]);
};
